import { DatePicker } from '@/components/ui/date-time-picker'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

export function PresetAmountsField({
  value,
  onChange,
}: {
  value: string
  onChange: (value: string) => void
}) {
  return (
    <>
      <Label htmlFor="campaign-presets">Preset gift amounts</Label>
      <Input
        id="campaign-presets"
        inputMode="decimal"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder="25, 50, 100, 250"
      />
      <p className="text-caption text-muted-foreground">
        Comma-separated dollar amounts. Leave empty to use association defaults.
      </p>
    </>
  )
}

export function CampaignWindowFields({
  openOn,
  closeOn,
  onOpenChange,
  onCloseChange,
}: {
  openOn: string
  closeOn: string
  onOpenChange: (value: string) => void
  onCloseChange: (value: string) => void
}) {
  return (
    <>
      <Label>Window</Label>
      <div className="flex flex-wrap items-center gap-2">
        <DatePicker id="campaign-open" label="Open date" value={openOn} onChange={onOpenChange} />
        <span className="text-caption text-muted-foreground">through</span>
        <DatePicker
          id="campaign-close"
          label="Close date"
          value={closeOn}
          onChange={onCloseChange}
        />
      </div>
    </>
  )
}
